export type Country = 'United States' | 'Canada';

const COUNTRY_MAP = {
  Canada: 'CA',
  'United States': 'US',
};

const DEFAULT_VALUE = 'US';

export const countryShortcut = (country: Country) => {
  return COUNTRY_MAP[country] || DEFAULT_VALUE;
};
